import { render } from "./OfferPriceView.vue?vue&type=template&id=57fb350a&scoped=true"
import script from "./OfferPriceView.vue?vue&type=script&lang=js"
export * from "./OfferPriceView.vue?vue&type=script&lang=js"

import "./OfferPriceView.vue?vue&type=style&index=0&id=57fb350a&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57fb350a"]])

export default __exports__